module.exports = __webpack_public_path__ + "img/blockables-instructions-3.b25adec9.png";